import gql from "graphql-tag"

export const editGdprPreferencesMutation = gql`
  mutation editGdprPreferences(
    $email: String!
    $source: String!
    $service: Boolean
    $marketing: Boolean
    $profiling: Boolean
    $third_parties: Boolean
    $terms_and_conditions: Boolean
  ) {
    editGdpr(
      email: $email
      source: $source
      service: $service
      marketing: $marketing
      profiling: $profiling
      third_parties: $third_parties
      terms_and_conditions: $terms_and_conditions
    ) {
      service
      email
      source
      marketing
      profiling
      third_parties
      terms_and_conditions
      date
    }
  }
`
